module.exports = __webpack_public_path__ + "static/media/head-drawings.53bedb18.png";